// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"563281a5","139":"31d6cfe0","160":"7c6e3837","191":"7c6e3837","327":"7910a993","615":"2f4e45b5","644":"e2b14a4e","673":"7c622046","907":"027973dd","921":"3fdb8ad1"}[chunkId] + ".chunk.css";
};